"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("../../assets/PPDropMenu.css");
var PPDropMenu = function (props) {
    var subMenuTop = props.subMenuTop ? (props.subMenuTop - 9) : 0;
    var timer;
    var onLeave = function () {
        clearTimeout(timer);
        timer = setTimeout(props.onLeave, 500);
    };
    return (react_1.default.createElement("div", { id: 'ppdropmenu_' + props.id, className: "pp-dropmenu ".concat(props.position || 'left'), onMouseOver: function () { return clearTimeout(timer); }, onMouseLeave: function () { return onLeave(); } },
        react_1.default.createElement("div", { className: "items" }, props.items),
        props.subItems &&
            react_1.default.createElement("div", { className: "subitems", style: {
                    maxHeight: "calc(100vh - ".concat(subMenuTop + 52, "px)"),
                    marginTop: "".concat(subMenuTop, "px")
                } }, props.subItems)));
};
exports.default = PPDropMenu;
